import { useDocumentTitle } from "@/lib/use-document-title";
import { useState } from "react";
import { StaffLayout } from "@/components/StaffLayout";
import { SmsBody } from "@/routes/af-portal.sms";
import { MailBody } from "@/routes/af-portal.mejl";
import { MessageSquare, Mail } from "lucide-react";

type Tab = "sms" | "mejl";

export default function UtskickPage() {
  useDocumentTitle("Kundutskick — ÅF-Portal");
  const [tab, setTab] = useState<Tab>("sms");

  return (
    <StaffLayout title="Kundutskick">
      <div className="flex flex-wrap gap-2 mb-6">
        <button
          onClick={() => setTab("sms")}
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-display transition ${tab === "sms" ? "bg-[var(--color-primary)] text-white" : "bg-white border border-border text-foreground hover:bg-muted"}`}
        >
          <MessageSquare size={14} /> SMS-utskick
        </button>
        <button
          onClick={() => setTab("mejl")}
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-display transition ${tab === "mejl" ? "bg-[var(--color-primary)] text-white" : "bg-white border border-border text-foreground hover:bg-muted"}`}
        >
          <Mail size={14} /> Mejlutskick
        </button>
      </div>

      {tab === "sms" ? <SmsBody /> : <MailBody />}
    </StaffLayout>
  );
}
